import { render, staticRenderFns } from "./Courseware.vue?vue&type=template&id=c8dc3060"
import script from "./Courseware.vue?vue&type=script&lang=js"
export * from "./Courseware.vue?vue&type=script&lang=js"
import style0 from "./Courseware.vue?vue&type=style&index=0&id=c8dc3060&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports